var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.modal.render)?_c(_vm.modal.component,{ref:"modalRef",tag:"component",attrs:{"mode":_vm.modal.mode},on:{"cancel":_vm.cancel,"save":_vm.save}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }